import React from "react";
import style from "./Filter.module.scss";
import { Select } from "antd";

const { Option } = Select;

export default function Filter({
    count,
    onSelect
}: {
    count: number;
    onSelect: (value: string) => void;
}) {
    return (
        <div className={style.root}>
            问题总数：{count}
            <Select
                showSearch
                placeholder="全部"
                optionFilterProp="children"
                className={style.Select}
                defaultValue="2"
                onSelect={onSelect}>
                <Option value={"2"}>全部</Option>
                <Option value={"1"}>已答</Option>
                <Option value={"0"}>未答</Option>
            </Select>
        </div>
    );
}
